import { lazy, Suspense, type ReactNode } from "react";

import { EmailIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const EmailInbox = lazy(() => import("./EmailInbox").then((m) => ({ default: m.EmailInbox })));
const EmailMessage = lazy(() =>
  import("./EmailMessage").then((m) => ({ default: m.EmailMessage }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading…</div>;
}

/** Gate the email routes on feature.email.access (client mirror of the server). */
function guard(element: ReactNode): ReactNode {
  return (
    <RequirePermission perm="feature.email.access" redirectTo={ROUTES.overview}>
      <Suspense fallback={<Loader />}>{element}</Suspense>
    </RequirePermission>
  );
}

export const emailFeature: FeatureModule = {
  id: "email",
  navItems: [
    {
      id: "email",
      label: "Email",
      path: ROUTES.email,
      icon: EmailIcon,
      requires: "feature.email.access",
    },
  ],
  routes: [
    { path: ROUTES.email, element: guard(<EmailInbox />) },
    { path: ROUTES.emailMessage, element: guard(<EmailMessage />) },
  ],
};
